/*
 * @Author: wblijinyang
 * @FilePath: /mall-fe/src/views/h5/Home/index.tsx
 * @Description: 移动端商城首页入口
 */
import { useContext } from 'react';
import { SiteContext } from 'libs/contexts';
import { Floors, Header, NavBar, BrandZone } from './components';
import Banner from './components/Banner';
import IndexTabBar from 'comps/IndexTabBar';
import { SITE_MODE } from 'libs/enums';
import { DeviceContext } from 'libs/contexts';
import HomeHireBannerMobile from 'comps/HomeHireBannerH5';
import LogisticsEntity from './components/LogisticsEntity'
import { webps } from 'libs/imgs';
import Headerbg from 'images/cscec3b/header-background.png';
// 统一引入一下swiper样式
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/pagination';
webps[Headerbg] = Headerbg;

interface IndexMobileProps {
  readonly floorsData: Array<FloorsProps>;
  readonly bannersData: Array<BannerEntity>;
  readonly brandsData: Array<BrandEntity>;
  readonly recommendData: Array<Omit<FloorsProps, 'children'> & { skuList: Array<SkuItem> }>;
  readonly hotData: Array<FloorsProps>;
  readonly hireBannerData: Array<BannerEntity>;
  readonly isMniprogramEnv: boolean;
  readonly isQywx: boolean;
  logisticsCount: number;
}

const IndexMobile = (props: IndexMobileProps) => {
  const {
    floorsData,
    bannersData,
    brandsData,
    recommendData,
    hotData,
    hireBannerData,
    isMniprogramEnv,
    isQywx,
    logisticsCount,
  } = props;
  const site = useContext(SiteContext);
  const { buildImgSrc } = useContext(DeviceContext);
  /*
    智能推荐没有可配置颜色的选项
    热销商品link根据bizSysNo拼接而来
    不破坏原数据,此处重新组装一下数据,参数归一化,便于后续统一处理
  */
  const reassemblyRecommend = {
    mobileBackgroundColor: '#D4E2FE',
    mobileTextColor: '#0080FF',
    children: recommendData,
    title: '智能推荐',
  } as unknown as FloorsProps;

  const reassemblyHot = hotData.map((category) => ({
    ...category,
    children: category.children?.map((product) => ({
      ...product,
      link: `/product/list?catId=${product.bizSysNo}`,
    })),
  }));

  return (
    <div className="page-content">
      <Header />
      <Banner banners={bannersData} isQywx={isQywx} />
      <NavBar isMiniprogramEnv={isMniprogramEnv} isQywx={isQywx} />

      {/* 移动端首页招租广告位 */}
      {<HomeHireBannerMobile hireBannerMobData={hireBannerData} isQywx={isQywx} />}

      {/* 在途运单 */}
      {!!logisticsCount && <LogisticsEntity logisticsCount={logisticsCount} />}

      {/* 智能推荐 */}
      {site?.mall?.enableSelfSiteMode === SITE_MODE.SHOP && (
        <Floors floors={[reassemblyRecommend]} />
      )}

      {/* 热销推荐 */}
      <Floors floors={reassemblyHot} />

      {/* 楼层 */}
      <Floors floors={floorsData} />

      {/* 第三方电商平台 */}
      <Floors Components={() => <BrandZone brandList={brandsData} />} />

      <IndexTabBar safeAreaInsetBottom />
      <style jsx>{`
        .page-content {
          padding-bottom: calc(70px + constant(safe-area-inset-bottom));
          padding-bottom: calc(70px + env(safe-area-inset-bottom));
          position: relative;
          font-size: 14px;
          font-weight: 400;
          z-index: 1;
          background: url(${buildImgSrc(Headerbg)});
          background-size: 100% 200px;
          background-repeat: no-repeat;
        }
      `}</style>
    </div>
  );
};

export default IndexMobile;
